module.exports = __webpack_public_path__ + "img/btn_partner.1768119790257.png";